import React, { Component, Suspense, createRef } from "react";
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "datatables.net-buttons/js/dataTables.buttons.js";
import "datatables.net-buttons/js/buttons.colVis.js";
import "datatables.net-buttons/js/buttons.flash.js";
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.print.js";
import clsx from "clsx";
import Moment from "moment";
import $ from "jquery";
import { KTSVG } from "../../../_metronic/helpers";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { DownloadExcel } from "../ExcelHelper";
import ReactSelect from "react-select";
import { AUTH_LOCAL_STORAGE_KEY } from "../../../app/modules/auth";
import Columns from '../../../_metronic/helpers/Columns';
import { getModuleDataDisplaySettingByKey, updateModuleDataDisplaySettingByKey } from "../../models/_user";
import { Option } from '../../../_metronic/helpers/MySelect';
import { getWorkOrderById, getWorkOrders } from "../../models/_worOrder";
import { ImageModal } from "./ImageModal";
import { SignatureImage } from "./SignatureImage";
import { WORK_ORDER_STATUS } from "../../../_metronic/helpers/enums";
import { Toaster } from "react-hot-toast";
import Breadcrumb from "../Common/Breadcrumb";
class WorkOrderList extends Component<any, any> {
    readonly props: any;

    constructor(props: any, state: any) {
        super(props);
        let searchParams = new URLSearchParams(window.location.search);
        const currentPage = searchParams.get('page');
        const fromDate = searchParams.get('from_date');
        const toDate = searchParams.get('to_date');
        const date = searchParams.get('date');
        const firstName = searchParams.get('first_name');
        const lastName = searchParams.get('last_name');
        const deploymentIdString = searchParams.get('deployment_manager_id');
        const deploymentIdsArray = deploymentIdString ? deploymentIdString.split(',').map((x) => x) : "";
        const locationIdString = searchParams.get('location_id');
        const locationIdsArray = locationIdString ? locationIdString.split(',').map((x) => x) : "";

        this.state = {
            addLoading: false,
            filterLoading: false,
            resetFrom: createRef(),
            resetTo: createRef(),
            resetDate: createRef(),
            downloadLoading: false,
            filterFromDate: fromDate || "",
            filterToDate: toDate || "",
            filterDeployment: deploymentIdsArray || "",
            filterLocation: locationIdsArray || "",
            filterFirstName: firstName || "",
            filterLastName: lastName || "",
            filterDate: date || "",
            loading: false,
            deploymentManagerSelected: null,
            locationSelected: null,
            managerDB: [],
            locationDB: [],
            machineDB: [],
            finalUrl: '',
            page: currentPage || 0,
            perPage: 50,
            moduleKeyName: 'workOrder_list',
            selectedColumns: [],
            workOrderImageModal: false,
            imageContent: {},
            currentWorkOrderId: "",
            signatureImageModal: false,
            sorting:"",
            currentlyOpenRecord: {},
            columnData: [
                { id: 0, label: 'Sr.No.', key: 'index' },
                { id: 1, label: 'Deployment Manager Name', key: 'deploymentManagerId' },
                { id: 2, label: 'Location Name', key: 'locationId' },
                { id: 3, label: 'Comment', key: 'comment' },
                { id: 4, label: 'Machine 1', key: 'machineId1' },
                { id: 5, label: 'Is Second Machine Installed', key: 'isSecondMachineInstalled' },
                { id: 6, label: 'Machine 2', key: 'machineId2' },
                { id: 7, label: 'First Name', key: 'firstName' },
                { id: 8, label: 'Last Name', key: 'lastName' },
                { id: 9, label: 'Date', key: 'date' },
                { id: 10, label: 'Signature', key: 'signature' },
                { id: 11, label: 'Freezer Installed', key: 'freezerInstalled' },
                { id: 12, label: 'Footer Installed', key: 'footerInstalled' },
                { id: 13, label: 'Sanitizer Installed', key: 'sanitizerInstalled' },
                { id: 14, label: 'Header Installed', key: 'headerInstalled' },
                { id: 15, label: 'Booster Bar Installed', key: 'boosterBarInstalled' },
                { id: 16, label: 'Drainage Installed', key: 'drainageInstalled' },
                { id: 17, label: 'Internet Connected', key: 'internetConnected' },
                { id: 18, label: 'Flavor Tags Installed', key: 'flavorTagsInstalled' },
                { id: 19, label: 'Service Sticker Installed', key: 'serviceStickerInstalled' },
                { id: 20, label: 'One Two Three Stickers Installed', key: 'oneTwoThreeStickersInstalled' },
                { id: 21, label: 'Installation Steps Palm Tree', key: 'installationStepsPalmTree' },
                { id: 22, label: 'Filled Freezer', key: 'filledFreezer' },
                { id: 23, label: 'Pressure With Weighing scale', key: 'pressureWithWeighingScale' },
                { id: 24, label: 'Blended Four Smoodies', key: 'blendedFourSmoodies' },
                { id: 25, label: 'Sanitizer', key: 'sanitizer' },
                { id: 26, label: 'Get Status', key: 'getStatus' },
                { id: 27, label: 'Drain Test', key: 'drainTest' },
                { id: 28, label: 'Water Pressure Above 3100', key: 'waterPressureAbove3100' },
                { id: 29, label: 'Making Smoodies', key: 'makingSmoodies' },
                { id: 30, label: 'Benefits Of Smoodi (Trained Staff)', key: 'benefitsOfSmoodi(Trained Staff)' },
                { id: 31, label: 'Accessing Service Menu (Trained Staff)', key: 'accessingServiceMenu(Trained Staff)' },
                { id: 32, label: 'Cleaning Wipers (Trained Staff)', key: 'cleaningWipers(Trained Staff)' },
                { id: 33, label: 'Checking Sanitizer (Trained Staff)', key: 'checkingSanitizer(Trained Staff)' },
                { id: 34, label: 'smoodi Store', key: 'smoodiStore' },
                { id: 35, label: 'Squeezing Cups Before Putting in Freezer', key: 'squeezingCupsBeforePuttingInFreezer' },
                { id: 36, label: 'Booster Pump', key: 'boosterPump' },
                { id: 37, label: 'Window Decal', key: 'windowDecal' },
                { id: 38, label: 'Door Decal', key: 'doorDecal' },
                { id: 39, label: 'Palm Tree', key: 'palmTree' },
                { id: 40, label: 'Neon Sign', key: 'neonSign' },
                { id: 41, label: 'Smoodi Mat', key: 'smoodiMat' },
                { id: 42, label: 'Video On TV', key: 'videoOnTv' },
                { id: 43, label: 'Video On Out door Sign', key: 'videoOnOutdoorSign' },
                { id: 44, label: 'Freezer Magnet', key: 'freezerMagnet' },
                { id: 45, label: 'Machine Side Sticker', key: 'machineSideSticker' },
                { id: 46, label: 'Out door Flag', key: 'outdoorFlag' },
                { id: 47, label: 'Roll Up Banner', key: 'rollUpBanner' },
                { id: 48, label: 'Action (Required Task)', key: 'action(Required Task)' },
                { id: 49, label: 'Priority', key: 'priority' },
                { id: 50, label: 'Due Date', key: 'dueDate' },
                { id: 51, label: 'Store Contact Name', key: 'storeContactName' },
                { id: 52, label: 'Store Contact Phone Number', key: 'storeContactPhoneNumber' },
                { id: 53, label: 'Store Contact Role', key: 'storeContactRole' },
                { id: 54, label: 'Store Manager Signature', key: 'storeManagerSignature' },
                { id: 55, label: 'Action', key: 'action' },
                { id: 56, label: 'Status', key: 'status' },

            ]
        };
    }


    async componentWillMount() {
    }

    async componentDidUpdate() {
        await this.handleWorkOrderFilterSet()
    }

    async componentDidMount() {
        var _ = this;
        await this.getFilterRecords();
        this.renderDataTable([]);
        $("body").on("click", ".image", async function () {
            const record: any = $(this).attr("data-recordId");
            const workOrderData = await getWorkOrderById(record);
            _.setState({
                workOrderImageModal: true,
                currentWorkOrderId: record,
                imageContent: workOrderData,
            })
        });
        $("body").on("click", ".signatureImage", async function () {
            const workOder: any = $(this).attr("data-recordId");
            _.setState({
                signatureImageModal: true,

                currentlyOpenRecord: workOder,
            });
        });
    }

    getFilter = () => {
        let filter: any = {};
        if (this.state.filterDeployment.length > 0) {
            filter["deployment_manager_id"] = { in: this.state.filterDeployment };
        }
        if (this.state.filterLocation.length > 0) {
            filter["location_id"] = { in: this.state.filterLocation };
        }

        if (this.state.filterFirstName) {
            filter["first_name"] = { like: "%" + this.state.filterFirstName + "%" };
        }
        if (this.state.filterLastName) {
            filter["last_name"] = { like: "%" + this.state.filterLastName + "%" };
        }
        if (this.state.filterDate) {
            const formattedDate = Moment(this.state.filterDate).format('YYYY-MM-DD');
            filter["date"] = { eq: formattedDate };
        }

        if (this.state.filterFromDate !== "" || this.state.filterToDate !== "") {
            filter["created_at"] = {};
        }
        if (this.state.filterFromDate !== "" && this.state.filterToDate === "") {
            filter["created_at"]["gt"] = new Date(
                this.state.filterFromDate
            ).toISOString();
        } else if (
            this.state.filterFromDate === "" &&
            this.state.filterToDate !== ""
        ) {
            filter["created_at"]["lt"] = new Date(
                this.state.filterToDate
            ).toISOString();
        } else if (
            this.state.filterFromDate !== "" &&
            this.state.filterToDate !== ""
        ) {
            filter["created_at"]["between"] = [
                new Date(this.state.filterFromDate).toISOString(),
                new Date(this.state.filterToDate).toISOString(),
            ];
        }
        return filter
    }
    getURL = (baseURL: string) => {
        const isApplyDeployMentFilter = this.state.filterDeployment;
        const isApplyFromDateFilter = this.state.filterFromDate;
        const isApplyToDateFilter = this.state.filterToDate;
        const isApplyFirstNameFilter = this.state.filterFirstName;
        const isApplyLastNameFilter = this.state.filterLastName;
        const isApplyLocationFilter = this.state.filterLocation;
        const isApplyDateFilter = this.state.filterDate;

        if (isApplyFromDateFilter) {
            let date = Moment(isApplyFromDateFilter).format('YYYY-MM-DD HH:mm')
            let encodedDate = encodeURIComponent(date);
            baseURL += `&from_date=${encodedDate}`
        }
        if (isApplyToDateFilter) {
            let date = Moment(isApplyToDateFilter).format('YYYY-MM-DD HH:mm')
            let encodedDate = encodeURIComponent(date);
            baseURL += `&to_date=${encodedDate}`
        }
        if (isApplyDateFilter) {
            let date = Moment(isApplyDateFilter).format('YYYY-MM-DD HH:mm')
            let encodedDate = encodeURIComponent(date);
            baseURL += `&date=${encodedDate}`
        }
        if (isApplyDeployMentFilter && isApplyDeployMentFilter.length > 0) {
            const deployMentIds = isApplyDeployMentFilter.join(',');
            baseURL += `&deployment_manager_id=${deployMentIds}`
        }
        if (isApplyLocationFilter) {
            const locationIds = isApplyLocationFilter.join(',');
            baseURL += `&location_id=${locationIds}`
        }
        if (isApplyFirstNameFilter) {
            let decodedFirstName = decodeURIComponent(isApplyFirstNameFilter);
            let encodedFirstName = encodeURIComponent(decodedFirstName);
            baseURL += `&first_name=${encodedFirstName}`;
        }
        if (isApplyLastNameFilter) {
            let decodedLastName = decodeURIComponent(isApplyLastNameFilter);
            let encodedLastName = encodeURIComponent(decodedLastName);
            baseURL += `&last_name=${encodedLastName}`;
        }

        return baseURL;
    }


    // rendering datatable jquery
    renderDataTable = async (rows: any) => {
        var _this = this;
        const filter = this.getFilter();
        await this.getColumnData();
        const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
        let authToken = "";
        if (lsValue) {
            const user = JSON.parse(lsValue);
            authToken = user.access_token;
        }

        $(document).ready(function () {
            $("#workOrderTable").DataTable().destroy();
            // eslint-disable-next-line
            const table = $("#workOrderTable").DataTable({
                pagingType: "full_numbers",
                serverSide: true,
                pageLength: _this.state.perPage,
                paging: true,
                stateSave: true,
                searching: false,
                "ajax": {
                    "url": process.env.REACT_APP_API_URL,
                    "type": "POST",
                    "contentType": "application/json",
                    "beforeSend": function (xhr) {
                        xhr.setRequestHeader('Authorization',
                            "Bearer " + authToken);
                    },
                    "data": function (d: any) {
                        var gql = `query  getWorkOrders(  
            $where: WorkOrderResolver_GetWorkOrders_FilterInputType,
            $paginate:PaginatorArgs,
            $extraFilter: WorkOrderExtraFilterInput
            ) {
                getWorkOrders(where: $where ,paginate: $paginate,extraFilter:$extraFilter) {
                    data {
                        id
                        deploymentManagerId
                        locationId
                        closeUpMedia
                        storeSetUpMedia
                        drainSetUpMedia
                        serialNumberMedia
                        comment
                        machineId1
                        status
                        isSecondMachineInstalled
                        machineId2
                        firstName
                        lastName
                        date
                        signature
                        storeContactName
                        storeContactPhoneNumber
                        storeContactRole
                        storeManagerSignature
                        createdAt
                        installationSteps{
                        freezerInstalled
                        footerInstalled
                        sanitizerInstalled
                        headerInstalled
                        boosterBarInstalled
                        drainageInstalled
                        internetConnected
                        flavorTagsInstalled
                        serviceStickerInstalled
                        oneTwoThreeStickersInstalled
                        palmTree
                        filledFreezer
                        pressureWithWeighingScale
                        }
                        testPerformance{
                        blendedFourSmoodies
                        sanitizer
                        getStatus
                        createdAt
                        drainTest
                        waterPressureAbove3100
                        }
                        staffTraining{
                            workOrderId
                        makingSmoodies
                        benefitsOfSmoodi
                        accessingServiceMenu
                        cleaningWipers
                        checkingSanitizer
                        smoodiStore
                        squeezingCupsBeforePuttingInFreezer
                        }
                        materialInstallation{
                        boosterPump
                        windowDecal
                        doorDecal
                        palmTree
                        neonSign
                        smoodiMat
                        videoOnTv
                        videoOnOutdoorSign
                        freezerMagnet
                        machineSideSticker
                        outdoorFlag
                        rollUpBanner
                        }
                        requiredTask{
                        action
                        priority
                        dueDate
                        }
                        }
                        totalPages
                        total
                        perPage
                        page
                  }
          }`;
                        const currentPage = (d?.start) ? (d.start / d.length) + 1 : 1;
                        let key= "";
                        const selectedColumnNo = d?.order[0]?.column;
                        switch (selectedColumnNo) {
                            case 0:
                                key = "id";
                                break;
                            case 1:
                                key = "deployment_manager_id";
                                break;  
                            case 2:
                                key = "location_id";
                                break;       
                            case 3:
                                key = "comment";
                                break;
                            case 4:
                                key = "machine_id_1";
                                break;
                            case 5:
                                key = "is_second_machine_installed";
                                break; 
                            case 6:
                                key = "machine_id_2";
                                break;
                            case 7:
                                key = "first_name";
                                break;
                            case 8:
                                key = "last_name";
                                break;
                            case 9:
                                key = "date";
                                break;   
                            case 10:
                                key = "signature";
                                break;  
                            default:
                                if (selectedColumnNo >= 11 && selectedColumnNo <= 59) {
                                 key = "created_at";
                                }
                                break;        
                        }
                        _this.setState({
                            sorting:d?.order[0]?.dir.toUpperCase()
                         })
                        var query = {
                            "operationName": null,
                            "query": gql,
                            "variables": {
                                "where": filter,
                                paginate: {

                                    "page": currentPage,
                                    "per_page": _this.state.perPage

                                },
                                "extraFilter": {
                                    "key": key,
                                    "value": d?.order[0].dir.toUpperCase()
                                }
                            }
                        };

                        return JSON.stringify(query);
                    },
                    "dataSrc": function (json) {

                        json.recordsTotal = json.data?.getWorkOrders?.total;
                        json.recordsFiltered = json.data?.getWorkOrders?.total;

                        const rows: any[] = [];
                        const records = json.data.getWorkOrders.data;

                        const currentPage = json.data.getWorkOrders.page;
                        const recordsPerPage = json.data.getWorkOrders.perPage;
                        const getDeploymentManagerName = (id: string) => {
                            const manager = _this.state.managerDB.find(
                                (record: any) => {
                                    return record.id === id
                                }
                            );
                            return manager ? manager.firstName : '';
                        };
                        const getLocationName = (id: string) => {
                            const location = _this.state.locationDB.find(
                                (record: any) => {
                                    return record.id === id
                                }
                            );
                            return location ? location.name : '';
                        };

                        let counter = (currentPage - 1) * recordsPerPage + 1;
                        let sorting = _this.state.sorting;

                        if (sorting === "ASC") {
                          counter = (currentPage - 1) * recordsPerPage + 1;
                        } else if (sorting === "DESC") {
                          counter = json.recordsTotal - (currentPage - 1) * recordsPerPage;
                        }
                        for (const record of records) {
                            let createdAt = "";
                            if (record.createdAt) {
                                createdAt = Moment.utc(record.createdAt)
                                    .local()
                                    .format("YYYY-MM-DD HH:mm:ss");
                            }
                            const tempRecord: any = {
                                id: counter,
                                recordId: record.id,
                                managerName: getDeploymentManagerName(record.deploymentManagerId),
                                locationName: getLocationName(record.locationId),
                                closeUpMedia: record.closeUpMedia,
                                storeSetUpMedia: record.storeSetUpMedia,
                                drainSetUpMedia: record.drainSetUpMedia,
                                serialNumberMedia: record.serialNumberMedia,
                                comment: record.comment,
                                machineSerialNumber1: record.machineSerialNumber1,
                                machineName1: record.machineName1,
                                machineSerialNumber2: record.machineSerialNumber2,
                                machineName2: record.machineName2,
                                machineId1: record.machineId1,
                                isSecondMachineInstalled: record.isSecondMachineInstalled === true ? "Yes" : "No",
                                machineId2: record.machineId2,
                                firstName: record.firstName,
                                lastName: record.lastName,
                                date: record.date ? Moment.utc(record.date)
                                    .local()
                                    .format("YYYY-MM-DD") : '',
                                signature: record.signature,
                                storeContactName: record.storeContactName,
                                storeContactPhoneNumber: record.storeContactPhoneNumber,
                                storeContactRole: record.storeContactRole,
                                storeManagerSignature: record.storeManagerSignature,
                                installationSteps: record.installationSteps,
                                testPerformance: record.testPerformance,
                                staffTraining: record.staffTraining,
                                materialInstallation: record.materialInstallation,
                                requiredTask: record.requiredTask,
                                status: record.status ? (record.status  === WORK_ORDER_STATUS.COMPLETED ? "Completed" : "Pending") : "",
                                createdAt,
                                record: record,
                            };
                            const subRecords = record.subTasks ?? "";
                            for (const subRecord of subRecords) {
                                subRecord["record"] = { ...subRecord };
                            }
                            rows.push(tempRecord);
                            if (sorting === 'ASC') {
                                counter++;
                            }else if(sorting === 'DESC'){
                                counter--;
                            }
                        }
                        if (rows && rows.length !== 0) {
                            _this.setState({
                                workOrderList: rows
                            })
                        }
                        return rows;
                    }
                },
                "initComplete": function (settings, json) {
                    table.page(Number(_this.state.page)).draw(false);

                },
                // data: rows,
                columns: [
                    {
                        name: "index",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('index'),
                        render: function (data, type, row) {
                            return row.id;

                        },
                    },
                    {
                        name: "deploymentManagerId",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('deploymentManagerId'),
                        render: function (data, type, row) {
                            let returnsData =
                            '<div><a class="clickable_entry" href="/workOrder/list/history/'+ row.recordId +
                            '"> ' +
                            row.managerName +
                            "</div></a>";
                            return returnsData;
                        },
                    },
                    {
                        name: "locationId",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('locationId'),
                        render: function (data, type, row) {
                            let returnsData =
                            '<div><a class="clickable_entry" href="/workOrder/list/history/'+ row.recordId +
                            '"> ' +
                            row.locationName +
                            "</div></a>";
                            return returnsData;
                        },
                    },
                    {
                        name: "comment",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('comment'),
                        render: function (data, type, row) {
                            return row.comment;
                        },
                    },

                    {
                        name: "machineId1",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('machineId1'),
                        render: function (data, type, row) {
                            const matchedMachine = _this.state.machineDB.find((machine: any) => machine.id === row.machineId1);
                            const machineName = matchedMachine ? matchedMachine.name : '';
                            const machineSerialNumber = matchedMachine ? matchedMachine.serialNumber : '';
                            return row.machineId1 ? `${machineSerialNumber} (${machineName})` : ''
                        },
                    },

                    {
                        name: "isSecondMachineInstalled",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('isSecondMachineInstalled'),
                        render: function (data, type, row) {
                            return row.isSecondMachineInstalled;
                        },
                    },
                    {
                        name: "machineId2",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('machineId2'),
                        render: function (data, type, row) {
                            const matchedMachine = _this.state.machineDB.find((machine: any) => machine.id === row.machineId2);
                            const machineName = matchedMachine ? matchedMachine.name : '';
                            const machineSerialNumber = matchedMachine ? matchedMachine.serialNumber : '';
                            return row.machineId2 ? `${machineSerialNumber} (${machineName})` : ''
                        },
                    },
                    {
                        name: "firstName",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('firstName'),
                        render: function (data, type, row) {
                            let returnsData =
                            '<div><a class="clickable_entry" href="/workOrder/list/history/'+ row.recordId +
                            '"> ' +
                            row.firstName +
                            "</div></a>";
                            return returnsData;
                        },
                    },
                    {
                        name: "lastName",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('lastName'),
                        render: function (data, type, row) {
                            let returnsData =
                            '<div><a class="clickable_entry" href="/workOrder/list/history/'+ row.recordId +
                            '"> ' +
                            row.lastName +
                            "</div></a>";
                            return returnsData;
                        },
                    },
                    {
                        name: "date",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('date'),
                        render: function (data, type, row) {
                            return row.date;
                        },
                    },
                    {
                        name: "signature",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('signature'),
                        render: function (data, type, row) {
                            const mediaUrls = row.signature;
                            return `
                              <div style="display: flex; flex-wrap: wrap; gap: 5px; max-width: 100%; overflow: auto;">
                                        <img 
                                          data-recordId="${mediaUrls}"
                                          class=" signatureImage"
                                          src="${mediaUrls}"
                                          alt="Signature"
                                          style="max-width: 90px; height: auto; margin-right: 5px; margin-top: 5px; cursor: pointer; object-fit: contain;"
                                        />
                              </div>
                            `;
                        }
                    },
                    {
                        name: "status",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('status'),
                        render: function (data, type, row) {
                            return row.status;
                        }
                    },
                    {
                        name: "freezerInstalled",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('freezerInstalled'),
                        render: function (data, type, row) {
                            return row.installationSteps && row.installationSteps.freezerInstalled
                        },
                    },

                    {
                        name: "footerInstalled",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('footerInstalled'),
                        render: function (data, type, row) {
                            return row.installationSteps && row.installationSteps.footerInstalled;
                        },
                    },
                    {
                        name: "sanitizerInstalled",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('sanitizerInstalled'),
                        render: function (data, type, row) {
                            return row.installationSteps && row.installationSteps.sanitizerInstalled;
                        },
                    },
                    {
                        name: "headerInstalled",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('headerInstalled'),
                        render: function (data, type, row) {
                            return row.installationSteps && row.installationSteps.headerInstalled;
                        },
                    },
                    {
                        name: "boosterBarInstalled",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('boosterBarInstalled'),
                        render: function (data, type, row) {
                            return row.installationSteps && row.installationSteps.boosterBarInstalled;
                        },
                    },
                    {
                        name: "drainageInstalled",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('drainageInstalled'),
                        render: function (data, type, row) {
                            return row.installationSteps && row.installationSteps.drainageInstalled;
                        },
                    },
                    {
                        name: "internetConnected",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('internetConnected'),
                        render: function (data, type, row) {
                            return row.installationSteps && row.installationSteps.internetConnected;
                        },
                    },
                    {
                        name: "flavorTagsInstalled",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('flavorTagsInstalled'),
                        render: function (data, type, row) {
                            return row.installationSteps && row.installationSteps.flavorTagsInstalled;
                        },
                    },

                    {
                        name: "serviceStickerInstalled",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('serviceStickerInstalled'),
                        render: function (data, type, row) {
                            return row.installationSteps && row.installationSteps.serviceStickerInstalled;
                        },
                    },
                    {
                        name: "oneTwoThreeStickersInstalled",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('oneTwoThreeStickersInstalled'),
                        render: function (data, type, row) {
                            return row.installationSteps && row.installationSteps.oneTwoThreeStickersInstalled;
                        },
                    },

                    {
                        name: "installationStepsPalmTree",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('installationStepsPalmTree'),
                        render: function (data, type, row) {
                            return row.installationSteps && row.installationSteps.palmTree;
                        },
                    },
                    {
                        name: "filledFreezer",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('filledFreezer'),
                        render: function (data, type, row) {
                            return row.installationSteps && row.installationSteps.filledFreezer;
                        },
                    },
                    {
                        name: "pressureWithWeighingScale",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('pressureWithWeighingScale'),
                        render: function (data, type, row) {
                            return row.installationSteps && row.installationSteps.pressureWithWeighingScale;
                        },
                    },
                    {
                        name: "blendedFourSmoodies",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('blendedFourSmoodies'),
                        render: function (data, type, row) {
                            return row.testPerformance && row.testPerformance.blendedFourSmoodies;
                        },
                    },

                    {
                        name: "sanitizer",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('sanitizer'),
                        render: function (data, type, row) {
                            return row.testPerformance && row.testPerformance.sanitizer;
                        },
                    },
                    {
                        name: "getStatus",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('getStatus'),
                        render: function (data, type, row) {
                            return row.testPerformance && row.testPerformance.getStatus;
                        },
                    },
                    {
                        name: "drainTest",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('drainTest'),
                        render: function (data, type, row) {
                            return row.testPerformance && row.testPerformance.drainTest;
                        },
                    },
                    {
                        name: "waterPressureAbove3100",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('waterPressureAbove3100'),
                        render: function (data, type, row) {
                            return row.testPerformance && row.testPerformance.waterPressureAbove3100;
                        },
                    },
                    {
                        name: "makingSmoodies",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('makingSmoodies'),
                        render: function (data, type, row) {
                            return row.staffTraining && row.staffTraining.makingSmoodies;
                        },
                    },
                    {
                        name: "benefitsOfSmoodi(Trained Staff)",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('benefitsOfSmoodi(Trained Staff)'),
                        render: function (data, type, row) {
                            return row.staffTraining && row.staffTraining.benefitsOfSmoodi;
                        },
                    },
                    {
                        name: "accessingServiceMenu(Trained Staff)",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('accessingServiceMenu(Trained Staff)'),
                        render: function (data, type, row) {
                            return row.staffTraining && row.staffTraining.accessingServiceMenu;
                        },
                    },
                    {
                        name: "cleaningWipers(Trained Staff)",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('cleaningWipers(Trained Staff)'),
                        render: function (data, type, row) {
                            return row.staffTraining && row.staffTraining.cleaningWipers;
                        },
                    },
                    {
                        name: "checkingSanitizer(Trained Staff)",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('checkingSanitizer(Trained Staff)'),
                        render: function (data, type, row) {
                            return row.staffTraining && row.staffTraining.checkingSanitizer;
                        },
                    },
                    {
                        name: "smoodiStore",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('smoodiStore'),
                        render: function (data, type, row) {
                            return row.staffTraining && row.staffTraining.smoodiStore;
                        },
                    },
                    {
                        name: "squeezingCupsBeforePuttingInFreezer",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('squeezingCupsBeforePuttingInFreezer'),
                        render: function (data, type, row) {
                            return row.staffTraining && row.staffTraining.squeezingCupsBeforePuttingInFreezer;
                        },
                    },
                    {
                        name: "boosterPump",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('boosterPump'),
                        render: function (data, type, row) {
                            return row.materialInstallation && row.materialInstallation.boosterPump;
                        },
                    },
                    {
                        name: "windowDecal",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('windowDecal'),
                        render: function (data, type, row) {
                            return row.materialInstallation && row.materialInstallation.windowDecal;
                        },
                    },
                    {
                        name: "doorDecal",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('doorDecal'),
                        render: function (data, type, row) {
                            return row.materialInstallation && row.materialInstallation.doorDecal;
                        },
                    },
                    {
                        name: "palmTree",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('palmTree'),
                        render: function (data, type, row) {
                            return row.materialInstallation && row.materialInstallation.palmTree;
                        },
                    },
                    {
                        name: "neonSign",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('neonSign'),
                        render: function (data, type, row) {
                            return row.materialInstallation && row.materialInstallation.neonSign;
                        },
                    },
                    {
                        name: "smoodiMat",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('smoodiMat'),
                        render: function (data, type, row) {
                            return row.materialInstallation && row.materialInstallation.smoodiMat;
                        },
                    },
                    {
                        name: "videoOnTv",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('videoOnTv'),
                        render: function (data, type, row) {
                            return row.materialInstallation && row.materialInstallation.videoOnTv;
                        },
                    },

                    {
                        name: "videoOnOutdoorSign",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('videoOnOutdoorSign'),
                        render: function (data, type, row) {
                            return row.materialInstallation && row.materialInstallation.videoOnOutdoorSign;
                        },
                    },
                    {
                        name: "freezerMagnet",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('freezerMagnet'),
                        render: function (data, type, row) {
                            return row.materialInstallation && row.materialInstallation.freezerMagnet;
                        },
                    },
                    {
                        name: "machineSideSticker",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('machineSideSticker'),
                        render: function (data, type, row) {
                            return row.materialInstallation && row.materialInstallation.machineSideSticker;
                        },
                    },
                    {
                        name: "outdoorFlag",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('outdoorFlag'),
                        render: function (data, type, row) {
                            return row.materialInstallation && row.materialInstallation.outdoorFlag;
                        },
                    },
                    {
                        name: "rollUpBanner",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('rollUpBanner'),
                        render: function (data, type, row) {
                            return row.materialInstallation && row.materialInstallation.rollUpBanner;
                        },
                    },
                    {
                        name: "action(Required Task)",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('action(Required Task)'),
                        render: function (data, type, row) {
                            const test = row.requiredTask.map((a: any) => {
                                return a.action
                            })
                            return test;
                        },
                    },
                    {
                        name: "priority",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('priority'),
                        render: function (data, type, row) {
                            const test = row.requiredTask.map((a: any) => {
                                return a.priority
                            })
                            return test;
                        },
                    },
                    {
                        name: "dueDate",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('dueDate'),
                        render: function (data, type, row) {
                            const test = row.requiredTask.map((a: any) => {
                                return a.dueDate ? Moment.utc(a.dueDate)
                                    .local()
                                    .format("YYYY-MM-DD") : ''
                            })
                            return test;
                        },
                    },
                    {
                        name: "storeContactName",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('storeContactName'),
                        render: function (data, type, row) {
                            return row.storeContactName;
                        },
                    },
                    {
                        name: "storeContactPhoneNumber",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('storeContactPhoneNumber'),
                        render: function (data, type, row) {
                            return row.storeContactPhoneNumber;
                        },
                    },
                    {
                        name: "storeContactRole",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('storeContactRole'),
                        render: function (data, type, row) {
                            return row.storeContactRole;
                        },
                    },
                    {
                        name: "storeManagerSignature",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('storeManagerSignature'),
                        render: function (data, type, row) {
                            const mediaUrls = row.storeManagerSignature;
                            return mediaUrls ?  `
                              <div style="display: flex; flex-wrap: wrap; gap: 5px; max-width: 100%; overflow: auto;">
                                        <img 
                                          data-recordId="${mediaUrls}"
                                          class=" signatureImage"
                                          src="${mediaUrls}"
                                          alt="storeManagerSignature"
                                          style="max-width: 90px; height: auto; margin-right: 5px; margin-top: 5px; cursor: pointer; object-fit: contain;"
                                        />
                              </div>
                            ` : "";
                        }
                    },  
                    {
                        name: "action",
                        visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('action'),
                        render: function (data, type, row) {
                            let returnData = "";

                            returnData +=
                                '<div data-bs-toggle="tooltip" title="Click here to view images"><button class="btn btn-secondary image p-2 px-4 m-1" data-recordId=\'' +
                                row.recordId +
                                "'><i class='fa fa-eye' style='font-size:1rem;'></i></button></div>";
                            return returnData;
                        },
                    },

                ],
                processing: true,
                destroy: true,
                dom: "Bfrtip",
                // order: [[0, "desc"]],
                lengthMenu: [
                    [10, 20, 30, 50, -1],
                    [10, 20, 30, 50, "All"],
                ],
                columnDefs: [
                    {
                        targets: 0,
                        render: function (data, type, row, meta) {
                            return type === "export" ? meta.row + 1 : data;
                        },
                    },
                ],
                createdRow: function (row, data, rowIndex) {
                    var title: any = [];
                    $("#workOrderTable thead tr th").each(function () {
                        title.push($(this).text());
                    });
                    $.each($("td", row), function (colIndex) {
                        $(this).attr("data-title", title[colIndex]);
                    });
                },

            });
            table.on('page', function () {
                const currentPage = table.page.info();

                _this.setState({
                    page: currentPage.page
                })

            });
            $(document)[0].oncontextmenu = function () { return false; }

            $('#workOrderTable tbody').mousedown(function (e) {
                if ('ontouchstart' in window || navigator.maxTouchPoints > 0 || /Mobi|Android/i.test(navigator.userAgent)) {
                    return true; // Do nothing if it's a touch screen device
                  }
                e.preventDefault()
                if (e.buttons === 1) return true;
                e.preventDefault();
                var top = e.clientY;
                var left = e.clientX;
                const recordString = $(e.target).parents('tr').find('a.clickable_entry').attr('data-value');
                let record;
                if (recordString) {
                    record = JSON.parse(recordString)
                }
                if (record) {
                    $('#view_image_link').attr('data-recordId', record.recordId)
                    $("#context-menu").css({
                        top: top,
                        left: left
                    }).show();
                }
                return false;
            })
            $('html').click(function () {
                $("#context-menu").hide();
            })
            $("#context-menu a").click(function (e) {
            });
            _this.displaySelectedColumns(table);
        });


        $(".dt-buttons").remove();
    };
    async getFilterRecords() {
    const {users,machines,locations} = this.props;
    this.setState({
        managerDB: users,
        locationDB: locations,
        machineDB: machines,
    });
    }


    handleDownloadExcel = async () => {
        this.setState({
            downloadLoading: true
        })
        const filter = this.getFilter();
        const result: any = await getWorkOrders(filter);
        const getDeploymentManagerName = (id: string) => {
            const manager = this.state.managerDB.find(
                (record: any) => {
                    return record.id === id
                }
            );
            return manager ? manager.firstName : '';
        };
        const getLocationName = (id: string) => {
            const location = this.state.locationDB.find(
                (record: any) => {
                    return record.id === id
                }
            );
            return location ? location.name : '';
        };

        const excelRecords = [];
        let counter = 0;
        const allKeys = this.state.columnData.map((col: any) => col.key);
        const selectedColumns = this.state.selectedColumns?.length > 0 ? this.state.selectedColumns : allKeys;
        for (const record of result.data) {
            const matchedMachine1 = this.state.machineDB.find((machine: any) => machine.id === record.machineId1);
            const machineName1 = matchedMachine1 ? matchedMachine1.name : '';
            const machineSerialNumber1 = matchedMachine1 ? matchedMachine1.serialNumber : '';
            const matchedMachine2 = this.state.machineDB.find((machine: any) => machine.id === record.machineId2);
            const machineName2 = matchedMachine2 ? matchedMachine2.name : '';
            const machineSerialNumber2 = matchedMachine2 ? matchedMachine2.serialNumber : '';
            counter++;
            const tempRecord: any = {};
            
            if (selectedColumns.includes('index')) tempRecord.id = counter;
            if (selectedColumns.includes('deploymentManagerId')) tempRecord["Manager Name"] = getDeploymentManagerName(record.deploymentManagerId);
            if (selectedColumns.includes('locationId')) tempRecord["Location Name"] = getLocationName(record.locationId);
            if (selectedColumns.includes('comment')) tempRecord["Comment"] = record.comment;
            if (selectedColumns.includes('machineId1')) tempRecord["MachineId 1"] = record.machineId1 ? `${machineSerialNumber1} (${machineName1})` : '';
            if (selectedColumns.includes('isSecondMachineInstalled')) tempRecord["Is Second Machine Installed"] = record.isSecondMachineInstalled === true ? "Yes" : "No";
            if (selectedColumns.includes('machineId2')) tempRecord["MachineId 2"] = record.machineId2 ? `${machineSerialNumber2} (${machineName2})` : '';
            if (selectedColumns.includes('firstName')) tempRecord["FirstName"] = record.firstName;
            if (selectedColumns.includes('lastName')) tempRecord["LastName"] = record.lastName;
            if (selectedColumns.includes('date')) tempRecord["Date"] = record.date ? Moment.utc(record.date).local().format("YYYY-MM-DD") : '';
            if (selectedColumns.includes('signature')) tempRecord["Signature"] = record.signature;
            if (selectedColumns.includes('freezerInstalled')) tempRecord["Freezer Installed"] = record?.installationSteps?.freezerInstalled;
            if (selectedColumns.includes('footerInstalled')) tempRecord["Footer Installed"] = record?.installationSteps?.footerInstalled;
            if (selectedColumns.includes('sanitizerInstalled')) tempRecord["Sanitizer Installed"] = record?.installationSteps?.sanitizerInstalled;
            if (selectedColumns.includes('headerInstalled')) tempRecord["Header Installed"] = record?.installationSteps?.headerInstalled;
            if (selectedColumns.includes('boosterBarInstalled')) tempRecord["Booster Bar Installed"] = record?.installationSteps?.boosterBarInstalled;
            if (selectedColumns.includes('drainageInstalled')) tempRecord["Drainage Installed"] = record?.installationSteps?.drainageInstalled;
            if (selectedColumns.includes('internetConnected')) tempRecord["Internet Connected"] = record?.installationSteps?.internetConnected;
            if (selectedColumns.includes('flavorTagsInstalled')) tempRecord["Flavor Tags Installed"] = record?.installationSteps?.flavorTagsInstalled;
            if (selectedColumns.includes('serviceStickerInstalled')) tempRecord["Service Sticker Installed"] = record?.installationSteps?.serviceStickerInstalled;
            if (selectedColumns.includes('oneTwoThreeStickersInstalled')) tempRecord["One Two Three Stickers Installed"] = record?.installationSteps?.oneTwoThreeStickersInstalled;
            if (selectedColumns.includes('installationStepsPalmTree')) tempRecord["Installation Steps Palm Tree"] = record?.installationSteps?.palmTree;
            if (selectedColumns.includes('filledFreezer')) tempRecord["Filled Freezer"] = record?.installationSteps?.filledFreezer;
            if (selectedColumns.includes('pressureWithWeighingScale')) tempRecord["Pressure With Weighing Scale"] = record?.installationSteps?.pressureWithWeighingScale;
            if (selectedColumns.includes('blendedFourSmoodies')) tempRecord["Blended Four Smoodies"] = record?.testPerformance?.blendedFourSmoodies;
            if (selectedColumns.includes('sanitizer')) tempRecord["Sanitizer"] = record?.testPerformance?.sanitizer;
            if (selectedColumns.includes('getStatus')) tempRecord["Get Status"] = record?.testPerformance?.getStatus;
            if (selectedColumns.includes('drainTest')) tempRecord["Drain Test"] = record?.testPerformance?.drainTest;
            if (selectedColumns.includes('waterPressureAbove3100')) tempRecord["Water Pressure Above 3100"] = record?.testPerformance?.waterPressureAbove3100;
            if (selectedColumns.includes('makingSmoodies')) tempRecord["Making Smoodies"] = record?.staffTraining?.makingSmoodies;
            if (selectedColumns.includes('benefitsOfSmoodi(Trained Staff)')) tempRecord["Benefits Of Smoodi (Trained Staff)"] = record?.staffTraining?.benefitsOfSmoodies;
            if (selectedColumns.includes('accessingServiceMenu(Trained Staff)')) tempRecord["Accessing Service Menu (Trained Staff)"] = record?.staffTraining?.accessingServiceMenu;
            if (selectedColumns.includes('cleaningWipers(Trained Staff)')) tempRecord["Cleaning Wipers (Trained Staff)"] = record?.staffTraining?.cleaningWipers;
            if (selectedColumns.includes('checkingSanitizer(Trained Staff)')) tempRecord["Checking Sanitizer (Trained Staff)"] = record?.staffTraining?.checkingSanitizer;
            if (selectedColumns.includes('smoodiStore')) tempRecord["Smoodi Store"] = record?.staffTraining?.smoodiStore;
            if (selectedColumns.includes('squeezingCupsBeforePuttingInFreezer')) tempRecord["Squeezing CupsBefore Putting In Freezer"] = record?.staffTraining?.squeezingCupsBeforePuttingInFreezer;
            if (selectedColumns.includes('boosterPump')) tempRecord["Booster Pump"] = record?.materialInstallation?.boosterPump;
            if (selectedColumns.includes('windowDecal')) tempRecord["Window Decal"] = record?.materialInstallation?.windowDecal;
            if (selectedColumns.includes('doorDecal')) tempRecord["Door Decal"] = record?.materialInstallation?.doorDecal;
            if (selectedColumns.includes('neonSign')) tempRecord["Neon Sign"] = record?.materialInstallation?.neonSign;
            if (selectedColumns.includes('smoodiMat')) tempRecord["Smoodi Mat"] = record?.materialInstallation?.smoodiMat;
            if (selectedColumns.includes('videoOnTv')) tempRecord["Video On TV"] = record?.materialInstallation?.videoOnTv;
            if (selectedColumns.includes('videoOnOutdoorSign')) tempRecord["Video On Out door Sign"] = record?.materialInstallation?.videoOnOutdoorSign;
            if (selectedColumns.includes('freezerMagnet')) tempRecord["Freezer Magnet"] = record?.materialInstallation?.freezerMagnet;
            if (selectedColumns.includes('machineSideSticker')) tempRecord["Machine Side Sticker"] = record?.materialInstallation?.machineSideSticker;
            if (selectedColumns.includes('outdoorFlag')) tempRecord["Out door Flag"] = record?.materialInstallation?.outdoorFlag;
            if (selectedColumns.includes('rollUpBanner')) tempRecord["Roll Up Banner"] = record?.materialInstallation?.rollUpBanner;
            if (selectedColumns.includes('action(Required Task)')) tempRecord["Action (Required Task)"] = record.requiredTask.map((a: any) => a.action).join(', ');
            if (selectedColumns.includes('priority')) tempRecord["Priority"] = record.requiredTask.map((a: any) => a.priority).join(', ');
            if (selectedColumns.includes('dueDate')) tempRecord["Due Date"] = record.requiredTask.map((a: any) => a.dueDate ? Moment.utc(a.dueDate).local().format("YYYY-MM-DD") : '',).join(', ');
            if (selectedColumns.includes('storeContactName')) tempRecord["Store Contact Name"] = record.storeContactName;
            if (selectedColumns.includes('storeContactPhoneNumber')) tempRecord["Store Contact Phone Number"] = record.storeContactPhoneNumber;
            if (selectedColumns.includes('storeContactRole')) tempRecord["Store Contact Role"] = record.storeContactRole;
            if (selectedColumns.includes('storeManagerSignature')) tempRecord["Store Manager Signature"] = record.storeManagerSignature;
            if (selectedColumns.includes('storeManagerSignature')) tempRecord["Store Manager Signature"] = record.storeManagerSignature;;
            if (selectedColumns.includes('status')) tempRecord["Status"] = record.status ?(record.status === WORK_ORDER_STATUS.COMPLETED ? "Completed" : "Pending") : "";
            excelRecords.push(tempRecord);
        }
        DownloadExcel(excelRecords, "SHEET_NAME", "Work_order");
        this.setState({
            downloadLoading: false
        })
    };


    refreshTable = async () => {
        await this.getFilterRecords();
        this.renderDataTable([]);
    }

    // filter data submit
    searchData = async () => {
        this.setState({
            addLoading: true,
        });
        const url = this.getURL(`/workOrder?page=${this.state.page}`);
        window.history.replaceState({}, '', url);;
        this.setState({
            finalUrl: this.getURL('')
        });

        this.refreshTable()
        this.renderDataTable([]);
        this.setState({
            addLoading: false,
        });
        return false;
    };
    removeSearch = async () => {
        this.setState({
            filterLoading: true,
        });

        // eslint-disable-next-line
        this.state.resetFrom.current.state.inputValue = "";
        // eslint-disable-next-line
        this.state.resetDate.current.state.inputValue = "";
        // eslint-disable-next-line
        this.state.resetTo.current.state.inputValue = "";
        this.setState({
            filterToDate: "",
            filterFromDate: "",
            filterFirstName: "",
            filterLastName: "",
            filterDate: "",
            filterLocation: "",
            deploymentManagerSelected: null,
            locationSelected: null,
            filterDeployment: "",
        });
        window.history.replaceState({}, '', "/workOrder");
        await this.getFilterRecords();
        this.renderDataTable([]);
        this.setState({
            filterLoading: false,
        });
        return false;
    };
    handleSurveyClose = () => {
        this.setState({
            signatureImageModal: false,

            currentlyOpenRecord: {},
        });
    };
    handleWorkOrderImageClose = () => {
        this.setState({
            workOrderImageModal: false,
            currentWorkOrderId: "",
            imageContent: {},
        })
    }
    // async getColumnData() {
    getColumnData = async () => {
        var _ = this;
        const data = await getModuleDataDisplaySettingByKey(this.state.moduleKeyName);
        if (data) {
            _.setState({ selectedColumns: data.metaValue })
            return data.metaValue;
        }
        return [];
    }

    displaySelectedColumns = async (table: any) => {
        var _this = this;
        if (_this.state.selectedColumns.length > 0) {
            table.settings().init().columns?.map(function (val: any, key: any) {
                if (!_this.state.selectedColumns.includes(val.name)) {
                    table.column(key).visible(false);
                  } else {
                    table.column(key).visible(true); // Ensure selected columns are made visible
                  }
                return false;
            });
        }
        $('#workOrderTable').show();
        return false;
    };

    handleColumnDataSelect = async (e: any) => {
        const selCol = (e.target.checked)
            ? [...this.state.selectedColumns, e.target.value]
            : this.state.selectedColumns.filter((item: string) => item !== e.target.value);
        this.setState({ selectedColumns: selCol });
    };

    handleColumnDataSubmit = async (e: any) => {
        const selectedColumns = this.state.selectedColumns;
        await updateModuleDataDisplaySettingByKey(this.state.moduleKeyName, selectedColumns);
        this.refreshTable();
    };
    handleSelectAll = () => {
        const { selectedColumns, columnData } = this.state;
        const allKeys = columnData.map((col: any) => col.key);
        if (selectedColumns.length === columnData.length) {
            this.setState({ selectedColumns: [] });
        } else {
            this.setState({ selectedColumns: allKeys });
        }
    };
    handleWorkOrderFilterSet = async () => {
        if (this.getURL('')) {
            if (this.state.filterDeployment) {
                const selectManager = this.state.managerDB.filter((data: any) => this.state.filterDeployment.includes(data.id))
                const finalSelectedManagerResponse = selectManager.map((x: any) => {
                    return {
                        value: x.id,
                        label: x.firstName
                    }
                })
                if (JSON.stringify(finalSelectedManagerResponse) !== JSON.stringify(this.state.deploymentManagerSelected)) {
                    this.setState({
                        deploymentManagerSelected: finalSelectedManagerResponse,
                    });
                }
            }
            if (this.state.filterLocation) {
                const selectLocation = this.state.locationDB.filter((data: any) => this.state.filterLocation.includes(data.id))
                const finalSelectedLocationResponse = selectLocation.map((x: any) => {
                    return {
                        value: x.id,
                        label: x.name
                    }
                })
                if (JSON.stringify(finalSelectedLocationResponse) !== JSON.stringify(this.state.locationSelected)) {
                    this.setState({
                        locationSelected: finalSelectedLocationResponse,
                    });
                }
            }
        }
    };
    render() {
        return (
            <Suspense>
                <div id="kt_app_toolbar" className="app-toolbar py-2 pt-4">
                    <div
                        id="kt_app_toolbar_container"
                        className="app-container container-xxl d-block d-lg-flex d-md-flex d-xl-flex flex-stack px-3"
                        style={{ maxWidth: "100%" }}
                    >
                        <div className="page-title d-flex flex-column justify-content-center flex-wrap">
                            <h1 className="page-heading d-flex text-dark fw-bold fs-1 flex-column justify-content-center my-0">
                                Work Order List
                            </h1>
                        </div>
                        <div className="d-flex align-items-center gap-2 gap-lg-3 mt-3 mt-lg-0 mt-md-0">
                            <button
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#workOrder-filter"
                                aria-expanded="false"
                                aria-controls="workOrder-filter"
                                className="btn btn-bg-light collapsed fw-bold m-0 p-0 px-5 py-3 align-items-center card-title text-center">
                                <KTSVG
                                    path="/media/icons/duotune/general/gen031.svg"
                                    className="svg-icon-4 me-1"
                                />
                                Filter
                            </button>
                            <Breadcrumb
                                links={[
                                    { label: "Home", href: "/dashboard", isActive: false },
                                    { label: "Work Order List", href: "", isActive: true },
                                ]}
                            />
                        </div>
                    </div>
                </div>


                <div className="collapse" id="workOrder-filter" aria-labelledby="workOrder-filter">
                    <div className="card mt-9">
                        <div className="card-body w-100 p-lg-7 p-md-7 p-5">
                            <div className="row mt-6">
                                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 ps-xl-5 mb-3">
                                    <label className="form-label fs-4 fw-bold">Created At (From Date)</label>
                                    <Datetime
                                        ref={this.state.resetFrom}
                                        closeOnSelect
                                        dateFormat="YYYY-MM-DD"
                                        timeFormat="HH:mm"
                                        value={this.state.filterFromDate}
                                        onChange={(e: any) => {
                                            const dt = e["_d"];
                                            this.setState({
                                                filterFromDate: dt,
                                            });
                                        }}
                                    />
                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                                    <label className="form-label fs-4 fw-bold">Created At (To Date)</label>
                                    <Datetime
                                        ref={this.state.resetTo}
                                        closeOnSelect
                                        dateFormat="YYYY-MM-DD"
                                        timeFormat="HH:mm"
                                        value={this.state.filterToDate}
                                        onChange={(e: any) => {
                                            const dt = e["_d"];
                                            this.setState({
                                                filterToDate: dt,
                                            });
                                        }}
                                    />
                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                                    <label className="form-label fs-4 fw-bold">Deployment Manager</label>
                                    <ReactSelect
                                        className="react-select"
                                        classNamePrefix="my-react-select"
                                        placeholder=""
                                        isMulti
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        onChange={(selected: any) => {
                                            const value = selected?.map((e: any) => e.value);
                                            this.setState({
                                                deploymentManagerSelected: selected,
                                                filterDeployment: value,
                                            });
                                        }}
                                        components={{
                                            Option,
                                        }}
                                        value={this.state.deploymentManagerSelected}
                                        options={Array.from(this.state.managerDB).map(
                                            (value: any) => {
                                                return {
                                                    value: value.id,
                                                    label: value.firstName,
                                                };
                                            }
                                        )}
                                    />

                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                                    <label className="form-label fs-4 fw-bold">Locations</label>
                                    <ReactSelect
                                        className="react-select"
                                        placeholder=""
                                        classNamePrefix="my-react-select"
                                        isMulti
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        onChange={(selected: any) => {
                                            const value = selected?.map((e: any) => e.value);
                                            this.setState({
                                                locationSelected: selected,
                                                filterLocation: value,
                                            });
                                        }}
                                        components={{
                                            Option,
                                        }}
                                        value={this.state.locationSelected}
                                        options={Array.from(this.state.locationDB).map(
                                            (value: any) => {
                                                return {
                                                    value: value.id,
                                                    label: value.name,
                                                };
                                            }
                                        )}
                                    />
                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                                    <label className="form-label fs-4 fw-bold">First Name</label>

                                    <input
                                        autoComplete="off"
                                        className={clsx("form-control")}

                                        name="filterFirstName"
                                        value={this.state.filterFirstName}
                                        onChange={(event: any) => {
                                            this.setState({
                                                filterFirstName: event.target.value,
                                            });
                                        }}
                                    />

                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                                    <label className="form-label fs-4 fw-bold">Last Name</label>

                                    <input
                                        autoComplete="off"
                                        className={clsx("form-control")}

                                        name="filterLastName"
                                        value={this.state.filterLastName}
                                        onChange={(event: any) => {
                                            this.setState({
                                                filterLastName: event.target.value,
                                            });
                                        }}
                                    />

                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 ps-xl-5 mb-3">
                                    <label className="form-label fs-4 fw-bold">Date</label>
                                    <Datetime
                                        ref={this.state.resetDate}
                                        closeOnSelect
                                        dateFormat="YYYY-MM-DD"
                                        timeFormat=""
                                        value={this.state.filterDate}
                                        onChange={(e: any) => {
                                            const dt = e["_d"];
                                            this.setState({
                                                filterDate: dt,
                                            });
                                        }}
                                    />
                                </div>

                            </div>
                            <div className="row">
                                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3 mb-lg-4">
                                    <button
                                        type="submit"
                                        onClick={this.searchData}
                                        className="btn btn-primary me-4 fs-4 p-0 w-100 px-6 py-3"
                                    >
                                        {this.state.addLoading && (
                                            <span
                                                className="indicator-progress"
                                                style={{ display: "block" }}
                                            >
                                                Please Wait..
                                                <span className="spinner-border spinner-border-sm align-middle ms-3 mb-1"></span>
                                            </span>
                                        )}
                                        {!this.state.addLoading && (
                                            <span className="indicator-label">ADD FILTER</span>
                                        )}
                                    </button>
                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3 mb-lg-4">
                                    <button
                                        type="submit"
                                        onClick={this.removeSearch}
                                        className="btn btn-primary me-4 fs-4 p-0 w-100 px-6 py-3"
                                    >
                                        {this.state.filterLoading && (
                                            <span
                                                className="indicator-progress"
                                                style={{ display: "block" }}
                                            >
                                                Please Wait..
                                                <span className="spinner-border spinner-border-sm align-middle ms-3 mb-1"></span>
                                            </span>
                                        )}
                                        {!this.state.filterLoading && (
                                            <span className="indicator-label">RESET FILTER</span>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Columns
                    columnData={this.state.columnData}
                    selectedColumns={this.state.selectedColumns}
                    handleColumnDataSelect={this.handleColumnDataSelect}
                    handleColumnDataSubmit={this.handleColumnDataSubmit}
                    handleSelectAll={this.handleSelectAll}
                />
                <div className="card mt-9">
                    <div className="card-body w-100 p-lg-7 p-md-7 p-5">
                        <div className="row">
                            <div className="col-12">
                                <div className="table-responsive p-0 pb-2 fs-6" id="data-table">
                                    <div className="row align-items-center justify-content-between">
                                        <div className="col-xl-2 col-lg-3 col-md-4 col-12">
                                        <button
                                            type="button"
                                            className="btn btn-bg-light btn-active-color-primary fw-bold btn-block w-100 p-0 px-4 py-3 mb-3"
                                            data-bs-toggle="modal"
                                            data-bs-target="#columnsModal"
                                            >
                                            Columns
                                        </button>
                                        </div>

                                        <div className="col-xl-2 col-lg-3 col-md-4 col-12">
                                            <button
                                                onClick={this.handleDownloadExcel}
                                                className="btn btn-bg-light btn-active-color-primary fw-bold btn-block w-100 p-0 px-4 py-3 mb-3"
                                            >
                                                {this.state.downloadLoading && (
                                                    <span
                                                        className="indicator-progress"
                                                        style={{ display: "block" }}
                                                    >
                                                        Please Wait..
                                                        <span className="spinner-border spinner-border-sm align-middle ms-3 mb-1"></span>
                                                    </span>
                                                )}
                                                {!this.state.downloadLoading && (
                                                    <span className="indicator-label"> <KTSVG
                                                        path="/media/icons/duotune/files/fil021.svg"
                                                        className="svg-icon-4 me-2"
                                                    />
                                                        Export Excel</span>
                                                )}

                                            </button>
                                        </div>
                                    </div>
                                    <table
                                        id="workOrderTable"
                                        className="table align-items-center responsive-table display justify-content-center mb-0 w-100"
                                    >
                                        <thead>
                                            <tr>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Sr.No
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Deployment Manager Name
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Location Name
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Comment
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Machine 1
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Is Second Machine Installed
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Machine 2
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    First Name
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Last Name
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Date
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Signature
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Status
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Freezer Installed
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Footer Installed
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Sanitizer Installed
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Header Installed
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Booster Bar Installed
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Drainage Installed
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Internet Connected
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Flavor Tags Installed
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Service Sticker Installed
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    One Two Three Stickers Installed
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Installation Steps Palm Tree
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Filled Freezer
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Pressure With Weighing Scale
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Blended Four Smoodies
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Sanitizer
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Get Status
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Drain Test
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Water Pressure Above 3100
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Making Smoodies
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Benefits Of Smoodi (Trained Staff)
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Accessing Service Menu (Trained Staff)
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Cleaning Wipers (Trained Staff)
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Checking Sanitizer (Trained Staff)
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Smoodi Store
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                     Squeezing Cups Before Putting In Freezer
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Booster Pump
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    window Decal 
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    door Decal 
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    palm Tree 
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    neon Sign 
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    smoodi Matt 
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    video On Tv 
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Video On Outdoor Sign 
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Freezer Magnet 
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Machine Side Sticker 
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Outdoor Flag 
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    RollUpBanner 
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Action (Required Task)
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Priority
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Due Date
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Store Contact Name
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Store Contact Phone Number
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Store Contact Role
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Store Manager Signature
                                                </th>
                                                <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                                                    Action
                                                </th>

                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                            </div>
                        </div>
                        
                            <ul
                                className="dropdown-menu"
                                aria-labelledby="dropdownMenuButton"
                                id="context-menu"
                            >
                                <li>
                                    <button
                                        className="dropdown-item image" id="view_image_link"
                                    >
                                        <i className="fa fa-pencil fs-6"></i>{" "}
                                        <span className="ms-2">View image</span>
                                    </button>
                                </li>

                            </ul>
                        {this.state.signatureImageModal === true && (
                            <SignatureImage
                                currentlyOpenRecord={this.state.currentlyOpenRecord}
                                signatureImageModal={this.state.signatureImageModal}
                                handleSurveyClose={this.handleSurveyClose}
                                refreshTable={this.refreshTable}
                            />
                        )}
                        {this.state.workOrderImageModal === true && (
                            <ImageModal
                                currentWorkOrderId={this.state.currentWorkOrderId}
                                imageContent={this.state.imageContent}
                                workOrderImageModal={this.state.workOrderImageModal}
                                handleWorkOrderImageClose={this.handleWorkOrderImageClose}
                                refreshTable={this.refreshTable}
                            />)}</div>
            <Toaster
                position="bottom-left"
                reverseOrder={false}
                gutter={8}
                containerClassName=""
                containerStyle={{}}
                toastOptions={{
                className: "",
                duration: 3000,
            }}
                />
                </div>
            </Suspense>
        );
    }
}

export default WorkOrderList;
